// 寶劍牌組 (Suit of Swords) - 14張
// 使用 Wikipedia Commons 官方圖庫確保穩定性

const swordsImages = {
  1: 'https://upload.wikimedia.org/wikipedia/commons/1/1a/Swords01.jpg',
  2: 'https://upload.wikimedia.org/wikipedia/commons/9/9e/Swords02.jpg',
  3: 'https://upload.wikimedia.org/wikipedia/commons/0/02/Swords03.jpg',
  4: 'https://upload.wikimedia.org/wikipedia/commons/b/bf/Swords04.jpg',
  5: 'https://upload.wikimedia.org/wikipedia/commons/2/23/Swords05.jpg',
  6: 'https://upload.wikimedia.org/wikipedia/commons/2/29/Swords06.jpg',
  7: 'https://upload.wikimedia.org/wikipedia/commons/3/34/Swords07.jpg',
  8: 'https://upload.wikimedia.org/wikipedia/commons/a/a7/Swords08.jpg',
  9: 'https://upload.wikimedia.org/wikipedia/commons/2/2f/Swords09.jpg',
  10: 'https://upload.wikimedia.org/wikipedia/commons/d/d4/Swords10.jpg',
  11: 'https://upload.wikimedia.org/wikipedia/commons/4/4c/Swords11.jpg',
  // 🔧 修復:寶劍騎士圖片已失效,替換為穩定來源
  12: 'https://upload.wikimedia.org/wikipedia/commons/b/b0/RWS_Tarot_12_Knight_of_Swords.jpg',
  13: 'https://upload.wikimedia.org/wikipedia/commons/d/d4/Swords13.jpg',
  14: 'https://upload.wikimedia.org/wikipedia/commons/3/33/Swords14.jpg'
};

export const swords = [
  {
    id: 's1',
    name: '寶劍一',
    nameEn: 'Ace of Swords',
    img: swordsImages[1],
    upright: {
      keywords: ['突破', '清晰', '真理', '新思想'],
      meaning: '像是一把切開迷霧的利劍,你將獲得思緒上的突破與極致的清晰感。看清真相的時刻到了。'
    },
    reversed: {
      keywords: ['混亂', '誤解', '言語傷人'],
      meaning: '思緒可能變得混亂,或者你用尖銳的言語傷害了別人。真相被掩蓋,難以做出正確判斷。'
    }
  },
  {
    id: 's2',
    name: '寶劍二',
    nameEn: 'Two of Swords',
    img: swordsImages[2],
    upright: {
      keywords: ['僵局', '逃避選擇', '自我封閉', '盲點'],
      meaning: '你蒙上了眼睛,拒絕面對眼前的困難抉擇。這是一個僵持不下的狀態,你需要平靜下來才能看見答案。'
    },
    reversed: {
      keywords: ['打破僵局', '資訊過載', '被迫決定'],
      meaning: '你被迫睜開眼睛面對現實,雖然過程可能不舒服,但僵局終於被打破了。'
    }
  },
  {
    id: 's3',
    name: '寶劍三',
    nameEn: 'Three of Swords',
    img: swordsImages[3],
    upright: {
      keywords: ['心碎', '悲傷', '分離', '痛苦的真相'],
      meaning: '這是一張代表心痛與悲傷的牌。某些真相或分離刺痛了你,但請記住,這也是釋放情緒的必經過程。'
    },
    reversed: {
      keywords: ['療癒', '壓抑痛苦', '逐漸釋懷'],
      meaning: '你正在慢慢從悲痛中恢復,或者你正在逃避內心的痛楚而拒絕療癒。'
    }
  },
  {
    id: 's4',
    name: '寶劍四',
    nameEn: 'Four of Swords',
    img: swordsImages[4],
    upright: {
      keywords: ['休息', '沉澱', '休養生息', '冥想'],
      meaning: '在激烈的戰鬥後,你需要一段時間的休息與沉澱。退一步,讓自己的身心靈得到恢復。'
    },
    reversed: {
      keywords: ['過度疲勞', '停滯不前', '焦躁不安'],
      meaning: '你可能已經休息了太久而變得停滯,或者明明需要休息卻依然焦慮地無法放鬆。'
    }
  },
  {
    id: 's5',
    name: '寶劍五',
    nameEn: 'Five of Swords',
    img: swordsImages[5],
    upright: {
      keywords: ['衝突', '損人不利己', '爭執', '殘酷的勝利'],
      meaning: '這是一場代價高昂的勝利。你可能贏了爭論,卻輸了關係。思考一下,這真的是你想要的結果嗎?'
    },
    reversed: {
      keywords: ['和解', '化解怨恨', '無謂的爭吵'],
      meaning: '你意識到了爭鬥的無意義,準備放下武器尋求和解,或者終於結束了一段消耗人的衝突。'
    }
  },
  {
    id: 's6',
    name: '寶劍六',
    nameEn: 'Six of Swords',
    img: swordsImages[6],
    upright: {
      keywords: ['過渡期', '療癒', '離開悲傷', '平靜的水面'],
      meaning: '你正在緩慢但確實地離開一個痛苦的環境,駛向更平靜的水域。這是一個過渡與漸進療癒的過程。'
    },
    reversed: {
      keywords: ['被過去拖累', '無法前進', '逃避問題'],
      meaning: '你帶著太多的心理包袱,導致無法順利邁向新的生活,或者問題依然在原地打轉。'
    }
  },
  {
    id: 's7',
    name: '寶劍七',
    nameEn: 'Seven of Swords',
    img: swordsImages[7],
    upright: {
      keywords: ['策略', '隱瞞', '獨自行動', '取巧'],
      meaning: '你可能需要運用一些策略或保持低調來達成目標,但也提醒你要小心周圍是否有不誠實的行為存在。'
    },
    reversed: {
      keywords: ['東窗事發', '冒名頂替綜合症', '坦誠'],
      meaning: '隱藏的秘密可能被揭露,或者你決定不再逃避,選擇坦誠面對問題。'
    }
  },
  {
    id: 's8',
    name: '寶劍八',
    nameEn: 'Eight of Swords',
    img: swordsImages[8],
    upright: {
      keywords: ['束縛', '無力感', '畫地自限', '受困'],
      meaning: '你感覺自己被困住了,但其實那些束縛你的繩索是你自己綁上的。只要你願意改變視角,隨時能重獲自由。'
    },
    reversed: {
      keywords: ['掙脫束縛', '重獲自由', '面對恐懼'],
      meaning: '你終於看清了恐懼的真面目,解開了心靈的枷鎖,準備重新掌控自己的人生。'
    }
  },
  {
    id: 's9',
    name: '寶劍九',
    nameEn: 'Nine of Swords',
    img: swordsImages[9],
    upright: {
      keywords: ['焦慮', '夢魘', '過度擔憂', '精神折磨'],
      meaning: '你的思緒在深夜裡折磨著你。大部分的恐懼其實只存在於你的腦海中,事情並沒有你想像的那麼糟。'
    },
    reversed: {
      keywords: ['向外求助', '恐懼成真', '釋放壓力'],
      meaning: '你要麼終於找人傾訴了你的焦慮,要麼就是一直擔心的事真的發生了,但反而讓你鬆了一口氣。'
    }
  },
  {
    id: 's10',
    name: '寶劍十',
    nameEn: 'Ten of Swords',
    img: swordsImages[10],
    upright: {
      keywords: ['谷底', '背叛', '徹底結束', '無法更糟'],
      meaning: '這是最黑暗的時刻,一種徹底的結束。但好消息是,事情已經壞到不能再壞了,接下來只會觸底反彈。'
    },
    reversed: {
      keywords: ['死灰復燃', '拒絕結束', '倖存'],
      meaning: '你正在從毀滅性的打擊中慢慢復原,或者你依然拒絕接受某件事已經徹底結束的事實。'
    }
  },
  {
    id: 's11',
    name: '寶劍侍者',
    nameEn: 'Page of Swords',
    img: swordsImages[11],
    upright: {
      keywords: ['好奇', '警覺', '溝通', '新的點子'],
      meaning: '你擁有敏銳的觀察力與好奇心,總是能提出尖銳的問題。這是一個學習與收集資訊的好時機。'
    },
    reversed: {
      keywords: ['八卦', '言過其實', '缺乏行動'],
      meaning: '可能流於空談或八卦,或者你的話語太過尖銳,沒有考慮到他人的感受。'
    }
  },
  {
    id: 's12',
    name: '寶劍騎士',
    nameEn: 'Knight of Swords',
    img: swordsImages[12],
    upright: {
      keywords: ['急躁', '行動迅速', '直言不諱', '野心'],
      meaning: '你帶著強烈的決心與邏輯,像一陣狂風般衝向目標。你的直言不諱可能會帶來效率,但也可能傷人。'
    },
    reversed: {
      keywords: ['魯莽', '攻擊性', '失去方向'],
      meaning: '你的急躁導致了混亂,或者在溝通中充滿了攻擊性,聽不進任何人的勸告。'
    }
  },
  {
    id: 's13',
    name: '寶劍皇后',
    nameEn: 'Queen of Swords',
    img: swordsImages[13],
    upright: {
      keywords: ['理智', '獨立', '清晰的界線', '洞察力'],
      meaning: '你具備極高的理智與清晰的判斷力。你不容易被情感左右,能客觀且公平地處理複雜的問題。'
    },
    reversed: {
      keywords: ['冷酷', '過度批判', '尖酸刻薄'],
      meaning: '你可能變得過於冷漠或嚴苛,用理智作為防衛的盾牌,把所有人都推得遠遠的。'
    }
  },
  {
    id: 's14',
    name: '寶劍國王',
    nameEn: 'King of Swords',
    img: swordsImages[14],
    upright: {
      keywords: ['權威', '邏輯', '真理', '專業'],
      meaning: '你掌握著絕對的理智與邏輯,是一個能夠制定規則並看透事物本質的權威人物。'
    },
    reversed: {
      keywords: ['操縱', '殘酷', '濫用權力'],
      meaning: '你可能利用你的聰明才智去操縱別人,或者變得不近人情,只看重規則而忽略了人性。'
    }
  }
];